import React from 'react';
import Swal from 'sweetalert2';
import BtnNuevaActividad from './BtnNuevaActividad';

const Hacienda = (props) => {

    const Eliminar = async (index) => {
        Swal.fire({
            title: '¿Seguro en Eliminar Actividad?',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Si, de acuerdo',
            denyButtonText: `No, Cancelar`,
        }).then(async (result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                props.EliminarActividad(index)
            }
        })

    }
    return (<>
        <h4>Datos Hacienda</h4>
        <div className='row'>
            <div className='col-75'>
                <span className="col-form-span" >Usuario Token</span>
                <input type="text" id="UsuarioToken" name="UsuarioToken" autoComplete='off' value={props.Gestor.UsuarioToken} onChange={props.CambiaDatosGestor}></input>
            </div>
            <div className='col-25'>
                <span className="col-form-span" >Clave Token </span>
                <input type="text" id="ClaveToken" name="ClaveToken" autoComplete='off' value={props.Gestor.ClaveToken} onChange={props.CambiaDatosGestor}></input>
            </div>
        </div>
        <div className='row'>
            <div className='col-75'>
                <span className="col-form-span" >Ruta Llave</span>
                <input type="text" id="RutaLlave" name="RutaLlave" disabled autoComplete='off' value={props.Gestor.RutaLlave} onChange={props.CambiaDatosGestor}></input>
                <input type="file" id="fileUpload" name="fileUpload" onChange={props.handleFileUpload} />
            </div>
            <div className='col-25'>
                <span className="col-form-span" >PIN </span>
                <input type="text" id="PIN" name="PIN" autoComplete='off' value={props.Gestor.PIN} onChange={props.CambiaDatosGestor}></input>
            </div>

        </div>
        <h4>Actividades Económicas</h4>
        <div className="row">

            <div className="col-50">
                <div className='row'>
                    <div className='col-25'>
                        <BtnNuevaActividad AgregarActividad={props.AgregarActividad} />
                    </div>
                    <div className='col-75'>
                        <button onClick={props.ObtenerActividadesdeDesdeHacienda}>Obtener Actividades</button>
                    </div>
                </div>

            </div>
            <div className="col-50"></div>
        </div>

        <div className="info" style={{ overflowX: 'auto' }}>
            <table id="tablaClientes" name="tablaClientes" className="table-striped table table-sm'">
                <thead>
                    <tr>
                        <th>Código</th>
                        <th>Nombre</th>
                        <th>Eliminar</th>
                    </tr>
                </thead>
                <tbody>
                    {props.LasActividades ? props.LasActividades.map((post, index) => {
                        return <tr key={index}>
                            <td>{post.CodigoActividad}</td>
                            <td>{post.NombreActividad}</td>
                            <td><button onClick={() => Eliminar(index)} >Eliminar</button></td>
                        </tr>
                    }) : null}
                </tbody>
            </table>



        </div>

    </>)
};

export default Hacienda;